import React from 'react';

const DeletePitch = ({ modalInfo, handleCloseModal, handleDeletePitch }) => {
  return (
    <div className="delete-modal-content">
      <p>Delete Pitch: {modalInfo.pitch_title}</p>
      <div className="delete-modal-buttons">
        <button
          className="btn btn--secondary-outline delete-modal-button"
          onClick={() => handleDeletePitch(modalInfo.ID)}
        >
          Delete
        </button>
        <button
          className="btn btn--primary-outline delete-modal-button"
          onClick={handleCloseModal}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeletePitch;
